import api from "../../../services/api";

const APIS = {
  CUSTOMER_REQUEST: "/CustomerRequests",
};

export const postCustomerRequestData = async (payload) => {
  try {
    const response = await api.post(APIS.CUSTOMER_REQUEST, payload);
    return response.data;
  } catch (error) {
    console.error("Error posting Customer Request data:", error);
     throw error;
  }
};